export default "__VITE_ASSET__Dnd_9DJB__"